import { FabricImage } from 'fabric'
import WebFont from 'webfontloader'

export const fonts = [
  'Myriad Pro Regular',
  'Delicious-Bold',
  'Verdana Italic',
  'Georgia Regular',
  'courier',
  'Comic Sans',
  'Maximum Impact Regular',
  'Monaco',
  'Optima',
  'Plaster Regular',
  'Engagement Regular',
  'Roboto-Bold',
  'EduNSWACTFoundation-Regular',
  'Anton-Regular',
  'Lobster-Regular',
  'DancingScript-Regular',
  'Pacifico-Regular',
  'Caveat-Regular',
  'IndieFlower-Regular',
  'Fondamento-Regular',
  'Andika-Regular',
  'Allan-Regular',
  'PollerOne-Regular',
  'UnifrakturMaguntia-Regular',
]

export const loadFonts = () =>
  WebFont.load({
    custom: {
      families: fonts,
    },
  })

export const loadBackgroundImage = async (canvas, url) => {
  const img = await FabricImage.fromURL(url)
  img.scaleToWidth(canvas.getWidth())
  img.scaleToHeight(canvas.getHeight())

  return img
}

export const createInitialCanvasHistoryState = () => ({
  stack: [],
  index: -1,
})

export const historyReducer = (state, action) => {
  const { activeCanvas } = action
  const canvasState = state.canvases ? state.canvases[activeCanvas] : null
  const maxEntries = 100

  switch (action.type) {
    case 'PUSH': {
      const { newState } = action
      // Drop off later entries if index is not at the top of the stack to prevent
      // redoing actions that no longer follow the current one.
      const nextStack = state.canvases[activeCanvas].stack
        .slice(0, canvasState.index + 1)
        .concat([newState])

      if (nextStack.length > maxEntries) nextStack.shift()

      return {
        ...state,
        canvases: {
          ...state.canvases,
          [activeCanvas]: {
            ...canvasState,
            stack: nextStack,
            index: nextStack.length - 1,
          },
        },
      }
    }
    case 'SAVE':
      var { key } = action
      var nextState = { ...state, key }
      // TODO: Pull this out of reducer.
      localStorage.setItem('cover-history', JSON.stringify(nextState))

      return nextState
    case 'UNDO':
      return {
        ...state,
        canvases: {
          ...state.canvases,
          [activeCanvas]: {
            ...canvasState,
            index: Math.max(0, canvasState.index - 1),
          },
        },
      }
    case 'REDO':
      return {
        ...state,
        canvases: {
          ...state.canvases,
          [activeCanvas]: {
            ...canvasState,
            index: Math.min(
              canvasState.stack.length - 1,
              canvasState.index + 1,
            ),
          },
        },
      }
    case 'RESET':
      if (action.initialState) {
        return { ...action.initialState }
      } else {
        return {
          key: '',
          canvases: {
            front: createInitialCanvasHistoryState(),
            back: createInitialCanvasHistoryState(),
            spine: createInitialCanvasHistoryState(),
          },
        }
      }
    default:
      return state
  }
}

export const initalObjectPosition = (
  currentCanvasName,
  margin,
  bleed,
  spineMargin,
) => {
  const position = {}

  if (currentCanvasName === 'spine') {
    position.top = spineMargin + bleed + 10
    position.left = spineMargin + 10
  } else {
    position.top = margin + bleed + 20

    if (currentCanvasName === 'front') {
      position.left = margin + 20
    } else {
      position.left = margin + bleed + 20
    }
  }

  return position
}

export const zoomCanvas = (canvas, factor, coords = null) => {
  let zoom = canvas.getZoom()

  const zoomStep = 0.05
  zoom += zoomStep * factor
  zoom = Math.max(1, Math.min(zoom, 2)) // clamp zoom

  if (coords) {
    canvas.zoomToPoint(coords, zoom)
  } else {
    canvas.setZoom(zoom)
  }

  // It's fiddly to get the canvas precisely back into the visible area, so reset at max zoom.
  if (zoom === 1) {
    canvas.absolutePan({ x: 0, y: 0 })
  }

  canvas.requestRenderAll()
}
